import { isWiseUiEnabled } from 'config/wiseUi';

import LegacySelectedCategories from 'components/containers/SelectedCategories/SelectedCategories';
import WiseSelectedCategories from 'components/wise/WiseSelectedCategories/WiseSelectedCategories';

const SelectedCategories = isWiseUiEnabled() ? WiseSelectedCategories : LegacySelectedCategories;

export default SelectedCategories;
